// True when the app is being served from the IQVerity custom domain
// (e.g. app.iqverity.com). The AskSmart, CaddieGames, and IQVerity front ends
// are the same Static Web App bundle on several domains; this lets the shared
// root route pick the IQVerity login/auth experience by hostname. Matches the
// apex and any subdomain so an accidental www/apex hit still routes correctly.
// Returns false for localhost / asksmart.ai so those keep the AskSmart experience.
export function isIqVerityHost(hostname?: string): boolean {
  const raw = hostname ?? (typeof window === "undefined" ? "" : window.location.hostname);
  const host = raw.toLowerCase();
  return host === "iqverity.com" || host.endsWith(".iqverity.com");
}
